export default "__VITE_ASSET__CEMWywuu__"